/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type DimConfigurationFragment = {
  __typename: "DimConfiguration"
  id: string
  productName: string
  productType: string
  isActive?: boolean | null
  dimensioningKey?: string | null
}

export const DimConfigurationFragmentDoc = gql`
  fragment DimConfiguration on DimConfiguration {
    id
    productName
    productType
    isActive
    dimensioningKey
  }
`
